import { applyPwaDocumentBranding, pwaPngArtwork } from '@next/core-lib/pwa';
import { title_Agrifirm as englishAppName, title_Agravis } from 'src/assets/i18n/en.json';
import { title_Agrifirm as dutchAppName } from 'src/assets/i18n/nl.json';

export function getPwaLocale(locale?: string): 'nl' | 'en' {
  return locale?.toLowerCase().split('-')[0] === 'nl' ? 'nl' : 'en';
}

export function getPwaAppName(tenant?: string, locale?: string): string {
  if (tenant === 'Agravis') return title_Agravis;
  return getPwaLocale(locale) === 'nl' ? dutchAppName : englishAppName;
}

export function getPwaFaviconUrl(tenant?: string): string {
  return `/assets/pwa/${tenant === 'Agravis' ? 'avidata' : 'agrifirm'}-favicon-96.png`;
}

export function applyPwaBranding(document: Document, tenant?: string, locale?: string): void {
  const appName = getPwaAppName(tenant, locale);
  const brand = tenant === 'Agravis' ? 'avidata' : 'agrifirm';

  applyPwaDocumentBranding(document, {
    manifestUrl:
      tenant === 'Agravis'
        ? '/assets/manifest-agravis.webmanifest'
        : `/assets/manifest_${getPwaLocale(locale)}.json`,
    appName,
    themeColor: tenant === 'Agravis' ? '#65b32e' : '#007f2d',
    ...pwaPngArtwork(`/assets/pwa/${brand}`),
    legacyTileImage: null,
  });
}
